import { useQuery, useMutation } from "@tanstack/react-query";
import api from "@services/api";

export function useFranchisesQuery(page, pageSize) {
  return useQuery({
    queryKey: ["franchise", page, pageSize],
    queryFn: async () => {
      const { data } = await api.get("/franchise", {
        params: { page, per_page: pageSize },
      });
      return data;
    },
    keepPreviousData: true,
  });
}

export function useCreateFranchiseMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post("/franchise", payload);
      return data;
    },
  });
}

export function useUpdateFranchiseMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.post(`/franchise/${id}`, payload);
      return data;
    },
  });
}

export function useDeleteFranchiseMutation() {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/franchise/${id}`);
      return data;
    },
  });
}

